export enum MembershipPublishingStateEnum {
	Published = 'published',
	Draft = 'draft',
	WaitingForStripeApproval = 'waiting-for-stripe-approval',
	Canceled = 'canceled',
}
